<template>
    <el-cascader
    v-model="dictVal"
    filterable
    clearable
    :disabled="policeDis"
    :show-all-levels="false"
    :options="dictOptions"
    :props="{ expandTrigger: 'hover' }"
    @focus="showCascader"
    @change="handleChange">
    </el-cascader>
</template>

<script>
import { get } from '@/utils/dict';
export default {
  props: {
    accident: {
      type: Object,
      default: () => {}
    },
    applicable: {
      type: Boolean,
      default: () => true
    },
    policeDis: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      dictOptions: [],
      dictVal: [],
      dictInfo: []
    }
  },
  created() {
     get('police_info').then(res => {
      if (res && res.length) {
        this.dictInfo = res
        let list = []
        res.forEach(el => {
          if (list && list.length) {
            let hasItem = false
            list.forEach(data => {
              if (data.label === el.remark) {
                hasItem = true
                data.children.push({value:el.dictLabel+'-'+el.dictValue,label:el.dictLabel+'-'+el.dictValue,})
              }
            })
            if (!hasItem) {
              list.push({
                value: el.remark,
                label: el.remark,
                children: [{
                  value:el.dictLabel+'-'+el.dictValue,
                  label:el.dictLabel+'-'+el.dictValue,
                }]
              })
            }
          }else {
            list.push({
                value: el.remark,
                label: el.remark,
                children: [{
                  value:el.dictLabel+'-'+el.dictValue,
                  label:el.dictLabel+'-'+el.dictValue,
                }]
              })
          }
        })
        this.dictOptions = list
      }
    })
  },
  methods:{
    showCascader() {
      this.$nextTick(()=>{
        // 阻止级联选择器滚动时的冒泡事件
        let pick = document.getElementsByClassName('el-cascader-panel')[0];
        pick.addEventListener('mousewheel',(e)=>{
          e.stopPropagation(); 
        });
      });
    },
    handleChange(value) {
      if (this.applicable) {
        if (value && value.length) {
          this.accident.policePhone = value[1].split('-')[1];
          this.accident.policeName = value[1].split('-')[0];
          this.accident.policeGroup = value[0];
        }else {
          this.accident.policePhone = ''
          this.accident.policeName = ''
          this.accident.policeGroup = ''
        } 
      }else {
        let OfflinePhone = ''
        console.log(value);
        OfflinePhone = value && value.length ? value[1].split('-')[1] : ''
        console.log(OfflinePhone);
        this.$emit('PhonData', OfflinePhone)
      }
    }
  }

}
</script>

<style>

</style>